import { NetworkRepWithSource } from "../../../report_summary/@types";

const CLASSIFICATIONS_COUNTER = {
  malicious: 0,
  suspicious: 0,
  goodware: 0,
  unknown: 0
} as Record<string, number>;

export const getNetworkReferencesCounts = (data: Array<NetworkRepWithSource>) =>
  data.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.classification]: acc[curr.classification] + 1
    }),
    CLASSIFICATIONS_COUNTER
  );
